// Sqlite stores timestamps in two shapes:
//   1. ISO 8601 with Z (e.g. "2025-04-30T12:00:00.000Z") — for new activities,
//      where the API normalizes occurred_at to .toISOString() before storing.
//   2. Naive UTC ("2025-04-30 12:00:00") — for `datetime('now')` defaults on
//      created_at / updated_at columns.
// Both should be interpreted as UTC. This helper handles both.
function parseTimestamp(raw: string): Date {
  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  const hasTz = /[Z+]|[+-]\d\d:?\d\d$/.test(normalized.slice(10));
  return new Date(hasTz ? normalized : normalized + "Z");
}

export function formatDateTime(iso: string): string {
  const d = parseTimestamp(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDate(iso: string): string {
  const d = parseTimestamp(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function toLocalDateTimeInput(iso: string): string {
  const d = parseTimestamp(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalDateTimeInput(value: string): string {
  if (!value) return new Date().toISOString();
  return new Date(value).toISOString();
}
